import externalPaymentsData from '../shared/externalPaymentsData';


export const GetPinPadCode = (paymentId) => {
    //pinpad is valid only for supporting external services
    if (!paymentId) return null;

    const externalPaymentService =
        externalPaymentsData.find(e => e.id === paymentId);

    //if not found or not supports pinpad, return
    if (!externalPaymentService || !externalPaymentService.isSupportsPinPad)
        return null;

    const localStorageName = `pinpadCode_${externalPaymentService.id}_${externalPaymentService.name}`;
    let pinpad = localStorage.getItem(localStorageName);

    if (pinpad) return pinpad;

    pinpad = "PINPAD" + prompt('Please Enter PinPad Code:');
    localStorage.setItem(localStorageName, pinpad);
    return pinpad;
};
export const ECompanyPayment = {
    PELECARD: 1,
    CREDITGUARD: 2,
    ZCREDIT: 9,
    BRIDGEPAY: 12,
    ["1"]: "PELECARD",
    ["2"]: "CREDITGUARD",
    ["9"]: "ZCREDIT",
    ["12"]: "BRIDGEPAY",
}

export const defaultAllowedPaymentProviderIDs = [
    ECompanyPayment.CREDITGUARD,
    ECompanyPayment.BRIDGEPAY
];

